import { render, staticRenderFns } from "./ResetAccountPassword.vue?vue&type=template&id=6e085d00&"
import script from "./ResetAccountPassword.vue?vue&type=script&lang=js&"
export * from "./ResetAccountPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetAccountPassword.vue?vue&type=style&index=0&id=6e085d00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports